import api from "../../api";

function buildDashboardFilter(filter) {
  if (!filter) return {};
  function toLocalYyyyMmDd(value) {
    if (!value) return undefined;
    // If it's a Date instance (PrimeVue Calendar), format as local YYYY-MM-DD
    if (value instanceof Date) {
      const y = value.getFullYear();
      const m = String(value.getMonth() + 1).padStart(2, "0");
      const d = String(value.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    }
    const str = String(value);
    // Already plain date
    if (/^\d{4}-\d{2}-\d{2}$/.test(str)) return str;
    // ISO or any parseable string → format as local date (not UTC)
    const date = new Date(str);
    if (!isNaN(date.getTime())) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    }
    return undefined;
  }
  
  let payload = {};
  if (filter.type === "day" && filter.day) {
    payload = { day: toLocalYyyyMmDd(filter.day) };
  } else if (filter.type === "period" && filter.from && filter.to) {
    payload = { from: toLocalYyyyMmDd(filter.from), to: toLocalYyyyMmDd(filter.to) };
  }

  if (filter.corporateId) {
    payload.CorporateId = filter.corporateId;
  }
  
  return payload;
}

export default {
  namespaced: true,
  state: () => ({
    dashboardCounts: {},
    bookingSourceStats: {},
    dailyBookingSourceStats: [],
    monthlyRideStats: {},
    routeStats: [],
    routeRides: {},
    routesList: [],
    captainsList: [],
    busesList: [],
    monthBookingsList: [],
    monthRidesList: [],
  }),
  getters: {
    getDashboardCounts(state) {
      return state.dashboardCounts;
    },
    getBookingSourceStats(state) {
      return state.bookingSourceStats;
    },
    getDailyBookingSourceStats: (state) => state.dailyBookingSourceStats,
    getMonthlyRideStats: (state) => state.monthlyRideStats,
    getRouteStats: (state) => state.routeStats,
    getRouteRides: (state) => state.routeRides,
    getRoutesList(state) {
      return state.routesList;
    },
    getCaptainsList(state) {
      return state.captainsList;
    },
    getBusesList(state) {
      return state.busesList;
    },
    getMonthBookingsList(state) {
      return state.monthBookingsList;
    },
    getMonthRidesList(state) {
      return state.monthRidesList;
    },
  },
  mutations: {
    SetDashboardCounts(state, data) {
      state.dashboardCounts = data;
    },
    SetBookingSourceStats(state, data) {
      state.bookingSourceStats = data;
    },
    setDailyBookingSourceStats(state, data) {
      state.dailyBookingSourceStats = data;
    },
    setMonthlyRideStats(state, data) {
      state.monthlyRideStats = data;
    },
    setRouteStats(state, data) {
      state.routeStats = data;
    },
    setRouteRides(state, { routeId, data }) {
      state.routeRides = { ...state.routeRides, [routeId]: data };
    },
    setRoutesList(state, data) {
      state.routesList = data;
    },
    setCaptainsList(state, data) {
      state.captainsList = data;
    },
    setBusesList(state, data) {
      state.busesList = data;
    },
    setMonthBookingsList(state, data) {
      state.monthBookingsList = data;
    },
    setMonthRidesList(state, data) {
      state.monthRidesList = data;
    },
  },
  actions: {
    fetchDashboardCounts({ commit }, filter) {
      return new Promise((resolve, reject) => {
        api()
          .post("dashboard/getCorporateCounts", buildDashboardFilter(filter), {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            commit("SetDashboardCounts", res.data.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetchBookingSourceStats({ commit }, filter) {
      return new Promise((resolve, reject) => {
        api()
          .post(
            "dashboard/getBookingSourceStats",
            buildDashboardFilter(filter),
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            commit("SetBookingSourceStats", res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetchDailyBookingSourceStats({ commit }, filter) {
      return new Promise((resolve, reject) => {
        api()
          .post(
            "dashboard/getDailyBookingSourceStats",
            buildDashboardFilter(filter),
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            commit("setDailyBookingSourceStats", res.data.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetchMonthlyRideStats({ commit }, filter) {
      return new Promise((resolve, reject) => {
        api()
          .post("dashboard/getMonthlyRideStats", buildDashboardFilter(filter), {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            commit("setMonthlyRideStats", res.data.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetchRouteStats({ commit }, filter) {
      return new Promise((resolve, reject) => {
        api()
          .post("dashboard/getRouteStats", buildDashboardFilter(filter), {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            commit("setRouteStats", res.data.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetchRouteRides({ commit }, filter) {
      return new Promise((resolve, reject) => {
        console.log("بسم  الله");
        const { routeId, ...rest } = filter || {};
        const payload = { routeId, ...buildDashboardFilter(rest) };
        if (filter.corporateId) {
            payload.CorporateId = filter.corporateId;
        }

        api()
          .post(
            "dashboard/getRouteRides",
            payload,
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            commit("setRouteRides", {
              routeId: filter.routeId,
              data: res.data.data,
            });
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetchCurrentCorporateRoutesList({ commit }) {
      return new Promise((resolve, reject) => {
        api()
          .get("dashboard/getCurrentCorporateRoutesList", {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            commit("setRoutesList", res.data.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetchCurrentCorporateCaptainsList({ commit }) {
      return new Promise((resolve, reject) => {
        api()
          .get("dashboard/getCurrentCorporateCaptainsList", {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            commit("setCaptainsList", res.data.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetchCurrentCorporateBusesList({ commit }) {
      return new Promise((resolve, reject) => {
        api()
          .get("dashboard/getCurrentCorporateBusesList", {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            commit("setBusesList", res.data.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetchCurrentMonthBookingsList({ commit }, filter) {
      return new Promise((resolve, reject) => {
        api()
          .post(
            "dashboard/getCurrentMonthBookingsList",
            buildDashboardFilter(filter),
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            commit("setMonthBookingsList", res.data.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetchCurrentMonthRidesList({ commit }, filter) {
      return new Promise((resolve, reject) => {
        api()
          .post(
            "dashboard/getCurrentMonthRidesList",
            buildDashboardFilter(filter),
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            commit("setMonthRidesList", res.data.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
